var AssociatedTokenInstruction;
(function (AssociatedTokenInstruction) {
    AssociatedTokenInstruction[AssociatedTokenInstruction["Create"] = 0] = "Create";
    AssociatedTokenInstruction[AssociatedTokenInstruction["CreateIdempotent"] = 1] = "CreateIdempotent";
    AssociatedTokenInstruction[AssociatedTokenInstruction["RecoverNested"] = 2] = "RecoverNested";
})(AssociatedTokenInstruction || (AssociatedTokenInstruction = {}));
const decodeCreateAssociatedTokenAccountInstruction = ({ programId, keys: [payer, associatedToken, owner, mint, systemProgramId, tokenProgramId], data }) => ({
    programId,
    keys: {
        payer,
        associatedToken,
        owner,
        mint,
        systemProgramId,
        tokenProgramId
    },
    data: { instruction: data[0] }
});
const decodeCreateAssociatedTokenAccountIdempotentInstruction = ({ programId, keys: [payer, associatedToken, owner, mint, systemProgramId, tokenProgramId], data }) => ({
    programId,
    keys: {
        payer,
        associatedToken,
        owner,
        mint,
        systemProgramId,
        tokenProgramId
    },
    data: { instruction: data[0] }
});
const decodeRecoverNestedInstruction = ({ programId, keys: [nestedAssociatedToken, nestedMint, destinationAssociatedToken, ownerAssociatedToken, ownerMint, owner, tokenProgramId], data }) => ({
    programId,
    keys: {
        nestedAssociatedToken,
        nestedMint,
        destinationAssociatedToken,
        ownerAssociatedToken,
        ownerMint,
        owner,
        tokenProgramId
    },
    data: { instruction: data[0] }
});
export const decodeAssociatedTokenAccountInstruction = (instruction) => {
    switch (instruction.data[0]) {
        // CreateAssociatedTokenAccount is with null/undefined or 0 as the data
        // AssociatedTokenAccount program code: https://github.com/solana-labs/solana-program-library/blob/a95c6d14d9305d6a77656bc6bc36c10d54ad7e97/associated-token-account/program/src/processor.rs#L37C1-L63C2
        // @solana/spl-token createAssociatedTokenAccountInstruction: https://github.com/solana-labs/solana-program-library/blob/a95c6d14d9305d6a77656bc6bc36c10d54ad7e97/token/js/src/instructions/associatedTokenAccount.ts#L17
        case null:
        case undefined:
        case AssociatedTokenInstruction.Create:
            return decodeCreateAssociatedTokenAccountInstruction(instruction);
        case AssociatedTokenInstruction.CreateIdempotent:
            return decodeCreateAssociatedTokenAccountIdempotentInstruction(instruction);
        case AssociatedTokenInstruction.RecoverNested:
            return decodeRecoverNestedInstruction(instruction);
        default:
            throw new Error('Invalid Associated Token Program Instruction');
    }
};
export const isCreateAssociatedTokenAccountInstruction = (decoded) => decoded.data.instruction === AssociatedTokenInstruction.Create ||
    decoded.data.instruction === null ||
    decoded.data.instruction === undefined;
export const isCreateAssociatedTokenAccountIdempotentInstruction = (decoded) => decoded.data.instruction === AssociatedTokenInstruction.CreateIdempotent;
export const isRecoverNestedInstruction = (decoded) => decoded.data.instruction === AssociatedTokenInstruction.RecoverNested;
//# sourceMappingURL=index.js.map